/**
 * Compute the default visibility for a reply based on the parent comment.
 *
 * Rules:
 * - ALL    → reply ALL (everyone sees the thread)
 * - SPECIFIC → reply SPECIFIC targeting the parent's author
 * - INTERNAL → stay INTERNAL
 */
import type { NegotiationParty, NegotiationComment } from '../../services/negotiationsApi'

export function getReplyVisibility(
  comment: Pick<NegotiationComment, 'visibility' | 'author'>,
  parties: Pick<NegotiationParty, 'actor' | 'tag_name'>[],
): string {
  if (comment.visibility === 'ALL') return 'ALL'

  if (comment.visibility === 'SPECIFIC') {
    const authorParty = parties.find(
      (p) => p.actor?.koblink_id === comment.author?.koblink_id,
    )
    if (authorParty) return `SPECIFIC:${authorParty.tag_name}`
  }

  return 'INTERNAL'
}
